import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { UserService } from 'src/app/services/core/users/user.service';

@UntilDestroy()
@Component({
  selector: 'app-trip-logs-modal',
  templateUrl: './trip-logs-modal.component.html',
  styleUrls: ['./trip-logs-modal.component.css']
})
export class TripLogsModalComponent {
  @Input() tripId: any;
  @Input() source?: any;
  @Output() closeModal = new EventEmitter<any>();
  expandedLogs: { [key: number]: boolean } = {};


  logsList: any = [];
  preCompanies: any = {};
  preUsers: any = {};
  search = '';

  constructor(
    private tripService: TripService,
    private companyService: CompanyService,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.getAllCompanies();
    this.getAllUsers();
    this.getLogs();
  }

  getLogs() {
    if(this.source=== 'billing'){
      this.tripService.getBillingTripsLogs(this.tripId)
        .pipe(untilDestroyed(this))
        .subscribe((data: any) => {
          if (data) this.logsList = data;
        });
    }else if( this.source === 'fundingsourceBilling'){  
      this.tripService.getFundingSourceBillingTripsLogs(this.tripId)
        .pipe(untilDestroyed(this))
        .subscribe((data: any) => {
          if (data) this.logsList = data;
        });
      }else if( this.source === 'onboarding'){  
      this.tripService.getFundingSourceBillingTripsLogs(this.tripId)
        .pipe(untilDestroyed(this))
        .subscribe((data: any) => {
          if (data) this.logsList = data;
        });
      }
    else {
      this.tripService.getTripsLogs(this.tripId)
        .pipe(untilDestroyed(this))
        .subscribe((data: any) => {
          if (data) this.logsList = data;
        });
    }

  }

  getAllCompanies() {
    const queryParams = { limit: 9999, isActive: true, isApproved: true };
    this.companyService.getPickerCompanies(queryParams)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data?.results) {
          this.preCompanies = data.results.reduce((obj: any, item: any) => {
            obj[item.id] = item;
            return obj;
          }, {});
        }
      });
  }

  getAllUsers() {
    const queryParams = { limit: 9999, sortBy: 'createdAt:desc', isActive: true };
    this.userService.getUsers(queryParams)
      .pipe(untilDestroyed(this))
      .subscribe((data: any) => {
        if (data?.results) {
          this.preUsers = data.results.reduce((obj: any, item: any) => {
            obj[item.id] = item;
            return obj;
          }, {});
        }
      });
  }

  mapPreValue(key: string, value: any): any {
    if (key.toLowerCase().includes('company') && this.preCompanies[value]) {
      return this.preCompanies[value].name || this.preCompanies[value].companyName;
    }
    if (key.toLowerCase().includes('user') && this.preUsers[value]) {
      return this.preUsers[value].fullName || this.preUsers[value].username;
    }
    return value;
  }

  getBadgeClass(key: string, value: any): string {
    const lower = key.toLowerCase();
    if (lower.includes('status')) {
      if (value?.toLowerCase() === 'completed') return 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300';
      if (value?.toLowerCase() === 'cancelled') return 'bg-rose-100 text-rose-700 dark:bg-rose-900/30 dark:text-rose-300';
      return 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300';
    }
    if (lower.includes('company')) return 'bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-300';
    if (lower.includes('user')) return 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300';
    if (lower.includes('fare')) return 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300';
    return 'bg-zinc-100 text-zinc-700 dark:bg-zinc-800 dark:text-zinc-200';
  }

  objectKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }

  isObject(value: any): boolean {
    return value && typeof value === 'object' && !Array.isArray(value);
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  onCloseModal() {
    this.closeModal.emit();
  }

toggleExpand(i: number) {
  this.expandedLogs[i] = !this.expandedLogs[i];
}
}
